module.exports = __webpack_public_path__ + "img/xn_home.461b3b1a.png";